export default __webpack_public_path__ + "static/media/title-bg-sm.f6adf048.svg";